var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _vm.channelSelectedNames.length > 0
            ? _c("el-col", { attrs: { span: 21 } }, [
                _c(
                  "div",
                  {
                    ref: "channel_content",
                    class: _vm.isShowAllChannel
                      ? "showChannelAll"
                      : "showChannelNotAll",
                  },
                  _vm._l(_vm.channelSelectedNames, function (item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.id,
                        staticStyle: { margin: "5px 5px" },
                        attrs: { size: "small" },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t"
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ])
            : _vm._e(),
          _vm.choiceChannelHeight > 40
            ? _c(
                "el-col",
                {
                  staticStyle: { display: "flex", "justify-content": "center" },
                  attrs: { span: 21 },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn_add_channel",
                      attrs: {
                        icon: _vm.isShowAllChannel
                          ? "el-icon-arrow-up"
                          : "el-icon-arrow-down",
                        type: "text",
                      },
                      on: {
                        click: function ($event) {
                          _vm.isShowAllChannel = !_vm.isShowAllChannel
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.isShowAllChannel ? "收起" : "展开") +
                          "\n\t\t\t"
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.isReadOnly
            ? _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-plus", type: "primary" },
                      on: { click: _vm.onAddChannel },
                    },
                    [_vm._v("新增渠道")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowChoiceChannel,
            "append-to-body": "",
            center: "",
            "modal-append-to-body": "",
            title: "选择渠道",
            top: "8vh",
            width: "55%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowChoiceChannel = $event
            },
            close: _vm.onCloseChannelDlg,
          },
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "20px" },
            attrs: {
              closable: false,
              "show-icon": "",
              title:
                "选择左侧可选渠道后，点击【到右边】按钮，则选中渠道，选择右侧已选渠道，点击【到左边】按钮，则取消渠道",
              type: "warning",
            },
          }),
          _c("virtual-transfer", {
            attrs: {
              "button-texts": ["到左边", "到右边"],
              data: _vm.channelCanSelectList,
              "can-select-list": _vm.channelCanSelectList,
              props: _vm.valueChange,
              titles: ["可选渠道", "已选渠道"],
              filterable: "",
            },
            on: {
              change: _vm.onChannelChange,
              "import-channels": _vm.onImportChannels,
            },
            model: {
              value: _vm.channelSelectedList,
              callback: function ($$v) {
                _vm.channelSelectedList = $$v
              },
              expression: "channelSelectedList",
            },
          }),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { margin: "0 20px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.onChoiceChannelCancel },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { margin: "0 20px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.onChoiceChannel },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }